import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../hooks/useLanguage';
import './About.css';
import { UserContext } from '../../context/UserContext';

const About_he = () => {
  const { user } = useContext(UserContext);
  const lang = useLanguage();

  return (
    <>
      <title>אודות SeegSoog | השקעות נדל"ן חכמות בארה"ב</title>
      <div className="about-container" dir="rtl">
        <div className="about-content">
          <h1>אודות SeegSoog.com</h1>
          <p>SeegSoog.com מהווה פלטפורמה שנבנתה כדי לקבל החלטות השקעה חכמות ומהירות יותר בנדל"ן ארה"ב. הוא מפגיש בין מוכרים למשקיעים רציניים, מתקנן את המספרים החשובים, ומוסיף ניתוח מבוסס בינה מלאכותית כך שכל עסקה ניתנת להערכה על בסיס שווה.</p>

          <h2>למה הוא קיים</h2>
          <p>
            SeegSoog התחיל מתסכול פשוט: ההגעה למוכרים הנכונים הייתה איטית, השוואת עסקאות על פי פרמטרים עקביים הייתה מבולגנת, וניתוח הצעות היה מסובך, קשה, ולקח יותר מדי זמן. פלטפורמה זו נוצרה כדי לתקן זאת על ידי יצירת פלטפורמה שמאחדת הצעות, משתמשת בקנה
            מידה אחיד לכולם, ומבצעת אוטומציה של הניתוח הכבד כך שהפוקוס יישאר על התשואה והסיכון.
          </p>

          <h2>מה האתר מציע</h2>
          <ul>
            <li>ריכוז מגוון הצעות השקעה במקום אחד.</li>
            <li>התאמה בין פרופיל ההשקעה של הקונה לבין נכס.</li>
            <li>מדדים פיננסיים המשתמשים בקנה מידה אחיד להשוואה אחידה בין ההצעות.</li>
            <li>דוחות לפי דרישה, בסיוע בינה מלאכותית, החושפים מידע, מגמות, רגישויות ודגלים אדומים.</li>
          </ul>

          <h2>הגישה שלנו</h2>
          <p>שקיפות, יושרה ומהירות מנחים כל תכונה—מנתונים ומתודולוגיה ברורים ועד לתהליכי עבודה יעילים של הודעות והחלטות. המטרה פשוטה: לעזור למשקיעים לפעול בביטחון והנגשת מוכרים אל קונים רציניים.</p>

          <p>
            <Link to={`/${lang}/map`}>אתרו הזדמנויות </Link>, למדו כיצד הכלים עובדים, או <Link to={`/${lang}/contact-us`}>צרו קשר</Link> כדי לשתף משוב ולעצב את מה שיבוא בהמשך.
          </p>
          {user.isLoggedIn && user.isAdmin && <p className="admin-message">אתה מחובר כמנהל מערכת.</p>}
        </div>
      </div>
    </>
  );
};

export default About_he;
